export default {
  light: {
    primary: "#536DFE",
    secondary: "#FF5C93",
    error: "#FF4081",
    warning: "#FFC260",
    success: "#3CD4A0",
    info: "#9013FE",
    textColor: "#FFFFFFFF",
    iconColor: "#FFFFFF59",
    grayBold: "#4a4a4a",
  },
};
